<script>

import apiHelper from "@/mixins/apiHelper.js";

export default {
  mixins: [
    apiHelper,
  ],
  props: {
    folderUuid: {
      type: String,
      required: false,
    }
  },
  emits: ['folderCreated'],
  data() {
    return {
      dialog: false,
      values: {
        name: '',
        shared: false,
      },
      errors: {
        name: false,
      },
    }
  },
  methods: {
    openDialog() {
      this.dialog = true;
      // Reset values
      this.values.name = '';
      this.values.shared = false;
    },
    closeDialog() {
      this.dialog = false;
    },
    /**
     * Create a new folder by sending a POST request to the API.
     *
     * @returns {Promise<Response>}
     */
    async createFolder() {
      // Clear previous toasts
      this.$toast.removeAllGroups();
      // Post new event to the API
      let payload = {};

      if (this.values.name === '') {
        this.errors.name = true;
        return;
      }

      // Add the name to the payload
      payload.name = this.values.name;
      payload.parent_id = this.folderUuid;
      payload.shared = this.values.shared;

      // Send request to API
      const response = await fetch('/api/file-folder', {
        method: 'POST',
        credentials: "include", // Set to make sure the cookies are send with the request.
        headers: this.requestHeaders,
        body: JSON.stringify(payload)
      });

      const status_code = response.status;

      if (status_code === 201) {
        let response_data = await response.json();
        // Close dialog
        this.closeDialog();
        // Emit event
        this.$emit('folderCreated');
        // Show message
        this.$toast.add({ severity: 'success', summary: 'Map aangemaakt', detail: 'Map is aangemaakt.', group: 'global', life: 4000 });
      }
      else {
        let response_data = await response.json();
        // Show error message
        this.$toast.add({ severity: 'error', summary: 'Fout', detail: 'De map kon niet aangemaakt worden.', group: 'errors' });
      }

      return response
    },
  }
}
</script>

<template>

  <Toast position="top-center" group="global" />
  <Toast position="top-center" group="errors" />

  <Dialog v-model:visible="dialog" modal header="Nieuwe map maken" :style="{ width: '32rem' }">

    <div class="flex flex-col gap-3">
      <div class="flex flex-col gap-1">
        <label for="name">Naam *</label>
        <InputText id="name" v-model="values.name" autocomplete="off" :invalid="errors.name" @input="errors.name = false" />
        <Message v-if="errors.name" severity="error">Naam is verplicht</Message>
      </div>
      <div class="flex flex-col gap-1">
        <div class="flex items-center gap-2 mt-2">
          <ToggleSwitch v-model="values.shared" inputId="shared" />
          <label for="shared">Gedeelde map</label>
        </div>
        <p class="text-gray-500">Gedeelde mappen zijn zichtbaar voor alle gebruikers.</p>
      </div>
    </div>

    <div class="flex justify-end gap-2 mt-3">
      <Button type="button" label="Annuleren" severity="secondary" @click="closeDialog"></Button>
      <Button type="button" label="Opslaan" @click="createFolder"></Button>
    </div>
  </Dialog>

</template>

<style>

</style>
